import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../../Components/Services/apiservices";

const apiServices = new ApiService();

function Officialpage() {
  const didMountRef = useRef(true);
  const navigate = useNavigate();

  const [pageData, setPageData] = useState({});
  const [pageContent, setPageContent] = useState("");

  useEffect(() => {
    if (didMountRef.current) {
      const dataString = {
        page_url: "cd-london-official",
      };

      apiServices.pagePostRequest(dataString).then((res) => {
        if (res.data.status === "success") {
          if (res.data.pageData != null) {
            setPageData(res.data.pageData);
            setPageContent(res.data.pageData.page_content);
          } else {
            navigate("/");
          }
        }
      });
    }

    didMountRef.current = false;
  }, [navigate]);

  return (
    <div className="official-page-main">
      <div className="official-page-card">

        {/* Dynamic CKEditor Content */}
        {pageContent && (
          <div
            className="official-page-content"
            dangerouslySetInnerHTML={{ __html: pageContent }}
          />
        )}

      </div>
    </div>
  );
}

export default Officialpage;